import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
    root: {},
    innerContainer: {
        flexDirection: "row",
        marginBottom: 15,
    },
    logoImage: {
        maxHeight: 60,
        maxWidth: 140,
        objectFit: "contain",
        objectPosition: "right",
    },
    titleRight: {
        textAlign: "right",
        fontSize: 18,
        fontWeight: 400,
    },
    titleLeft: {
        textAlign: "left",
        fontSize: 18,
        fontWeight: 400,
    },
    dateTimeText: {
        fontSize: 9,
        fontWeight: 400,
    },
    titleContainer: {
        flex: 1,
        justifyContent: "flex-end",
    },
    dateTimeContainer: {
        flex: 1,
        textAlign: "center",
        justifyContent: "flex-end",
    },
    logoContainerRight: {
        flex: 1,
        alignItems: "flex-end",
        justifyContent: "flex-end",
    },
    logoContainerLeft: {
        flex: 1,
        alignItems: "flex-start",
        justifyContent: "flex-start",
    },
    separator: {
        height: 1,
        width: "100%",
        backgroundColor: "#D0D0D0",
    },
});
